import { render } from "./CarTitle.vue?vue&type=template&id=72c5e6d9"
import script from "./CarTitle.vue?vue&type=script&lang=js"
export * from "./CarTitle.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./CarTitle.vue?vue&type=style&index=0&id=72c5e6d9&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script